module.exports = __webpack_public_path__ + "static/media/pointer.2281b1d6.svg";